export const isDateClosedOutForRoom = (roomId, dateKey, closeout) => {
  return closeout[roomId]?.[dateKey] === true;
};
